module.exports = __webpack_public_path__ + "media/src/images/excel-4ed438a50180b3de657f34451626ea91.png";